import Icon from 'veui/components/Icon'

Icon.register({
  'mark-at': {
    paths: [
      {
        d: 'M708 246.27A351.74 351.74 0 00380.93 32c-93.9.81-181.8 37.88-247.51 104.4S31.7 291.26 32 385.16a352 352 0 00316.84 349.1c1.07.1 2.14.15 3.2.15a32 32 0 003.12-63.84A288 288 0 0196 385c-.25-76.88 29.21-149.18 82.95-203.58S304.61 96.67 381.48 96a288 288 0 01222.86 473.46 15.49 15.49 0 01-17.88 4.79 15.29 15.29 0 01-10.46-15V256a32 32 0 00-61.41-12.61A191.27 191.27 0 00384 192c-105.87 0-192 86.13-192 192s86.13 192 192 192a191.24 191.24 0 00128-49v32.28a79.2 79.2 0 0052.5 75.11 81 81 0 0027.84 5 79.42 79.42 0 0060.94-28.64A352.35 352.35 0 00708 246.27zM384 512a128 128 0 11128-128 128.14 128.14 0 01-128 128z'
      }
    ],
    width: '768',
    height: '768'
  }
})
